import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { CustomerGroup } from '../../../../content/enums/organisation/customer-group';
import { OrganisationData } from '../../../../content/interfaces/organisation/organisation-data';
import { PaymentData } from '../../../../content/interfaces/payment/payment-data';
import { CustomerStatusTagPipe } from '../../../../content/pipes/customer-status-tag.pipe';
import { KeyToIconPipe } from '../../../../core/pipes/key-to-icon.pipe';
import { I18nService } from '../../../../core/services/i18n.service';
import { SpsCustomIconComponent } from '../../sps-custom-icon/sps-custom-icon.component';
import { SpsPaymentStatusTagComponent } from '../../sps-payment-status-tag/sps-payment-status-tag.component';

@Component({
  selector: 'customer-data-details-dialog',
  imports: [
    Tag,
    CustomerStatusTagPipe,
    TableModule,
    SpsCustomIconComponent,
    NgClass,
    KeyToIconPipe,
    SpsPaymentStatusTagComponent
  ],
  templateUrl: './customer-data-details-dialog.component.html',
})
export class CustomerDataDetailsDialogComponent {

  i18n = inject(I18nService);

  @Input() organisationData: OrganisationData;
  @Input() organisationPaymentTypes: PaymentData[] = [];

  protected readonly CustomerGroup = CustomerGroup;
}
